module.exports = __webpack_public_path__ + "df1dcf5ca273de710a4bc467232a34d2.MP3";